import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@repo/ui";
import undoIcon from "../../../assets/icons/undo _white.svg";
import AnimatedCard from "../../../components/AnimatedCard/AnimatedCard";
import PageContainer from "../../../components/PageContainer/PageContainer";
import withAuth from "../../../hoc/withAuth/withAuth";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_pages_ThankYouMessageSuccess";

const ThankYouMessageSuccess: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const { giftId } = useParams<{ giftId: string }>();
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (!giftId) return;
    // Navigate back to the Gift Detail page
    navigate(`/my-table/gift/${giftId}`);
  };

  return (
    <PageContainer>
      <div className="mt-16"></div>
      <AnimatedCard className="bg-white max-w-lg w-full">
        <h2 className="text-xl font-bold mb-4">{t("heading")}</h2>
        <p className="text-gray-600 mb-4">{t("message")}</p>
        <Button
          type="primary"
          className="w-full"
          onClick={handleGoBack}
          label={
            <div className="flex items-center justify-between">
              <span>{t("backToGift")}</span>
              <img src={undoIcon} alt={t("backAlt")} className="ml-2 h-4 w-4" />
            </div>
          }
        />
      </AnimatedCard>
    </PageContainer>
  );
};

export default withAuth(withTranslations(LOCALE)(ThankYouMessageSuccess));
